import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from "../../Admin/CreateCourse/ThreeColumnTableRow";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class DetailsBHS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { implementation } = this.props;
        return (
            <div>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            name="Naziv"
                            keyName="name"
                            value={implementation.studyProgram.name}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.name}
                        />
                        <ThreeColumnTableRow
                            name="ECTS"
                            keyName="ects"
                            value={implementation.studyProgram.ects}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.ects}
                        />
                        <ThreeColumnTableRow
                            name="Trajanje (godine)"
                            keyName="durationYear"
                            value={implementation.studyProgram.durationYear}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.durationYear}
                        />
                        <ThreeColumnTableRow
                            name="Trajanje (semestri)"
                            keyName="durationSemester"
                            value={implementation.studyProgram.durationSemester}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.durationSemester}
                        />
                        <ThreeColumnTableRow
                            name="Akademska godina početka"
                            keyName="academicYearStart"
                            value={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            academicYears={this.state.academicYears}
                            defValue={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                        />
                        <ThreeColumnTableRow
                            name="Studijski ciklus"
                            keyName="studyCycle"
                            value={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.displayName} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            studyCycles={JSON.parse(localStorage.getItem('studyCycles'))}
                            defValue={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.displayName} <br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Organizacione jedinice"
                            keyName="studyProgramOrganizationalUnits"
                            value={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.name} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            organizationalUnits={this.state.organizationalUnitDTOs}
                            defValue={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.name}<br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Titula"
                            keyName="titleName"
                            value={implementation.studyProgramTitle.name}
                            onChange={this.onChange}
                            disabled
                            edit={this.state.edit}
                            defValue={implementation.studyProgramTitle.name}
                        />
                        {/*<ThreeColumnTableRow*/}
                        {/*    name="Jezici"*/}
                        {/*    keyName="languages"*/}
                        {/*    value={implementation.languageIds ? implementation.languageIds.map(el => (<div>{this.getLanguageName(el)} <br /></div>)) : null}*/}
                        {/*    onChange={this.handleInputChange}*/}
                        {/*    edit={this.state.edit}*/}
                        {/*    languages={this.state.allLanguages}*/}
                        {/*    defValue={implementation.languageIds ? implementation.languageIds[0] : null}*/}
                        {/*/>*/}

                        <ThreeColumnTableRow
                            name="Opis"
                            keyName="description"
                            value={implementation.studyProgram.description}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.description}
                        />
                        <ThreeColumnTableRow
                            name="Detalji"
                            keyName="details"
                            value={implementation.studyProgram.details}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.details}
                        />
                        <ThreeColumnTableRow
                            name="Klasifikacija kvalifikacija"
                            keyName="classificationOfQualification"
                            value={implementation.studyProgram.classificationOfQualification}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.classificationOfQualification}
                        />
                        <ThreeColumnTableRow
                            name="Uslovi upisa"
                            keyName="enrollmentTerms"
                            value={implementation.studyProgram.enrollmentTerms}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.enrollmentTerms}
                        />
                        <ThreeColumnTableRow
                            name="Pravila studiranja"
                            keyName="studyRules"
                            value={implementation.studyProgram.studyRules}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyRules}
                        />
                        <ThreeColumnTableRow
                            name="Skala ocjenjivanja"
                            keyName="gradingScale"
                            value={implementation.studyProgram.gradingScale}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.gradingScale}
                        />

                        <ThreeColumnTableRow
                            name="Mogućnost upisa na sljedeći ciklus"
                            keyName="nextCycleEnrollmentPossibility"
                            value={implementation.studyProgram.nextCycleEnrollmentPossibility}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.nextCycleEnrollmentPossibility}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Profesionalni status"
                            keyName="professionalStatus"
                            value={implementation.studyProgram.professionalStatus}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.professionalStatus}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Ciljevi učenja"
                            keyName="studyGoals"
                            value={implementation.studyProgram.studyGoals}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyGoals}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Ishodi učenja"
                            keyName="studyOutcomes"
                            value={implementation.studyProgram.studyOutcomes}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyOutcomes}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Dodatne informacije"
                            keyName="additionalInformation"
                            value={implementation.studyProgram.additionalInformation}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.additionalInformation}
                        />

                        <ThreeColumnTableRow
                            name="Izvor dodatnih informacija"
                            keyName="additionalInformationSource"
                            value={implementation.studyProgram.additionalInformationSource}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.additionalInformationSource}
                            textArea
                        />

                    </Table.Body>
                </Table>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/DetailsBHS.js